export { ImgixImage } from "./ImgixImage"
export type { ImgixImageProps } from "./ImgixImage"
